/* state.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { atom, useAtom, useAtomValue } from "jotai";
import { expandedStateFormatSelection, collapsedStateFormatSelection } from "../utils/format-selection-object";
import { SplitView, SplitViewCol } from "../components/split-view";
import JSONTree from "../components/json-tree";
import { Heading, HeadingWithButton, HeadingButton } from "../components/heading";
import theme from "../theme";
import { activeMarksAtom } from "../state/active-marks";
import { expandPathAtom } from "../state/expand-path";
import { editorStateAtom } from "../state/editor-state";
import { logNodeFromJSON } from "../utils/log-node-from-json";
var _32 = "._1hvw1o36:focus{outline-width:medium}";
var _31 = "._49pcglyw:focus{outline-style:none}";
var _30 = "._nt751r31:focus{outline-color:currentColor}";
var _29 = "._30l35y2n:hover{color:#cdd6f4}";
var _28 = "._irr31wye:hover{background-color:rgba(203,166,247,.4)}";
var _27 = "._d0altlke:hover{cursor:pointer}";
var _26 = "._2rko1l7b{border-radius:3px}";
var _25 = "._v564111k{transition:background .3s,color .3s}";
var _24 = "._19itglyw{border:none}";
var _23 = "._11q7glyw{background:none}";
var _22 = "._syaz4yqd{color:rgba(205,214,244,.6)}";
var _21 = "._syazonp9{color:#fab387}";
var _20 = "._18u0idpf{margin-left:0}";
var _19 = "._otyridpf{margin-bottom:0}";
var _18 = "._2hwxhage{margin-right:.5em}";
var _17 = "._19pkidpf{margin-top:0}";
var _16 = "._syazx4b6{color:#89dceb}";
var _15 = "._1e0c1o8l{display:inline-block}";
var _14 = "._ca0qpd1z{padding-top:.25em}";
var _13 = "._18u01x4e{margin-left:1em}";
var _12 = "._otyrhage{margin-bottom:.5em}";
var _11 = "._2hwxidpf{margin-right:0}";
var _10 = "._19pkhage{margin-top:.5em}";
var _9 = "._129lrdoj+._129lrdoj{padding-top:9px}";
var _8 = "._vchhusvi{box-sizing:border-box}";
var _7 = "._1ul9mgvx{min-width:180px}";
var _6 = "._18m915vq{overflow-y:hidden}";
var _5 = "._1reo15vq{overflow-x:hidden}";
var _4 = "._19bvidpf{padding-left:0}";
var _3 = "._n3tdrdoj{padding-bottom:9px}";
var _2 = "._u5f3idpf{padding-right:0}";
var _ = "._ca0qidpf{padding-top:0}";
var JSONTreeWrapper = function JSONTreeWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0qidpf _u5f3idpf _n3tdrdoj _19bvidpf _1reo15vq _18m915vq"])
  }, children));
};
var Section = function Section(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1ul9mgvx _vchhusvi _129lrdoj"])
  }, children));
};
var Group = function Group(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_10, _11, _12, _13]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_19pkhage _2hwxidpf _otyrhage _18u01x4e"])
  }, children));
};
var GroupRow = function GroupRow(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_14]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0qpd1z"])
  }, children));
};
var Key = function Key(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15, _16, _17, _18, _19, _20]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1o8l _syazx4b6 _19pkidpf _2hwxhage _otyridpf _18u0idpf"])
  }, children));
};
var ValueNum = function ValueNum(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_21]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_syazonp9"])
  }, children));
};
var LogNodeButton = function LogNodeButton(_ref7) {
  var children = _ref7.children,
    onClick = _ref7.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32]), /*#__PURE__*/React.createElement("button", {
    "data-test-id": "__prosemirror_devtools_log_node_button__",
    onClick: onClick,
    className: ax(["_syaz4yqd _11q7glyw _19itglyw _v564111k _2rko1l7b _d0altlke _irr31wye _30l35y2n _nt751r31 _49pcglyw _1hvw1o36"])
  }, children));
};
export function getItemString(doc, action) {
  return function getItemStringWithBindedDoc(type, value, defaultView, keysCount) {
    var logButton = /*#__PURE__*/React.createElement(LogNodeButton, {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        action({
          doc: doc,
          node: value
        });
      }
    }, "log");
    if (type === "Object" && value.type) {
      return /*#__PURE__*/React.createElement("span", null, "{} ", value.type, " ", logButton);
    }
    return /*#__PURE__*/React.createElement("span", null, defaultView, " ", keysCount, " ", logButton);
  };
}
function getItemStringForMark(type, value, defaultView, keysCount) {
  if (type === "Object" && value.type) {
    return /*#__PURE__*/React.createElement("span", null, "{} ", value.type);
  }
  return /*#__PURE__*/React.createElement("span", null, defaultView, " ", keysCount);
}
function _shouldExpandNode(expandPath, nodePath) {
  var path = [].concat(nodePath).reverse();
  if (!expandPath) return false;

  // Expand attrs if node has them.
  // expandPath.push("attrs");

  if (path.length > expandPath.length) return false;
  if (path.join(".") === expandPath.join(".")) return true;
  if (path.every(function (el, idx) {
    return el === expandPath[idx];
  })) return true;
  return false;
}
export { _shouldExpandNode as shouldExpandNode };
var selectionAtom = atom(false);
export default function StateTab() {
  var _useAtom = useAtom(selectionAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    selectionExpanded = _useAtom2[0],
    setExpanded = _useAtom2[1];
  var activeMarks = useAtomValue(activeMarksAtom);
  var expandPath = useAtomValue(expandPathAtom);
  var state = useAtomValue(editorStateAtom);
  var doc = state === null || state === void 0 ? void 0 : state.doc.toJSON();
  if (!state) return null;
  var logNode = logNodeFromJSON(state);
  return /*#__PURE__*/React.createElement(SplitView, {
    testId: "__prosemirror_devtools_tabs_state__"
  }, /*#__PURE__*/React.createElement(SplitViewCol, {
    grow: true
  }, /*#__PURE__*/React.createElement(HeadingWithButton, null, /*#__PURE__*/React.createElement(Heading, null, "Current Doc"), /*#__PURE__*/React.createElement(HeadingButton, {
    onClick: function onClick() {
      return console.log(state);
    }
  }, "Log State")), /*#__PURE__*/React.createElement(JSONTree, {
    data: doc,
    hideRoot: true,
    getItemString: getItemString(doc, logNode),
    shouldExpandNode: function shouldExpandNode(nodePath) {
      return _shouldExpandNode(expandPath, nodePath);
    }
  })), /*#__PURE__*/React.createElement(SplitViewCol, {
    sep: true,
    minWidth: 220
  }, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(HeadingWithButton, null, /*#__PURE__*/React.createElement(Heading, null, "Selection"), /*#__PURE__*/React.createElement(HeadingButton, {
    onClick: function onClick() {
      return setExpanded(!selectionExpanded);
    }
  }, selectionExpanded ? "▼" : "▶")), /*#__PURE__*/React.createElement(JSONTreeWrapper, null, /*#__PURE__*/React.createElement(JSONTree, {
    data: selectionExpanded ? expandedStateFormatSelection(state.selection) : collapsedStateFormatSelection(state.selection),
    hideRoot: true
  }))), /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Heading, null, "Active Marks"), /*#__PURE__*/React.createElement(JSONTreeWrapper, null, activeMarks.length ? /*#__PURE__*/React.createElement(JSONTree, {
    data: activeMarks,
    hideRoot: true,
    getItemString: getItemStringForMark
  }) : /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(GroupRow, null, /*#__PURE__*/React.createElement(Key, null, "no active marks"))))), /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Heading, null, "Document Stats"), /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(GroupRow, null, /*#__PURE__*/React.createElement(Key, null, "nodeSize:"), /*#__PURE__*/React.createElement(ValueNum, null, state.doc.nodeSize)), /*#__PURE__*/React.createElement(GroupRow, null, /*#__PURE__*/React.createElement(Key, null, "childCount:"), /*#__PURE__*/React.createElement(ValueNum, null, state.doc.childCount))))));
}